import { message, Modal, notification as antNotification } from 'antd';

message.config({ maxCount: 1 });
antNotification.config({ duration: 7 });

export const info = (content: string) => {
  message.info(content);
};

export const success = (content: string, modal = false, onOk = () => {}) => {
  if (modal) {
    message.destroy();
    Modal.success({
      title: 'Success',
      content,
      onOk,
    });
  } else {
    message.success(content);
  }
};

interface GraphQLError {
  message?: string;
  graphQLErrors?: {
    message: string;
  }[];
}

type Content = GraphQLError | string;

const isGraphQLError = (content: Content): content is GraphQLError => (
  typeof content === 'object' && !!(content?.message || content?.graphQLErrors)
);

export const error = (content: Content, modal = true) => {
  let errMessage: string | undefined;
  if (isGraphQLError(content)) {
    errMessage = content.graphQLErrors?.map(({ message: m }) => m).join('<br>')
      || content.message;
  } else {
    errMessage = content;
  }

  if (modal) {
    message.destroy();
    Modal.error({
      title: 'Oops, something went wrong...',
      content: errMessage,
    });
  } else {
    message.error(errMessage);
  }
};

export const warning = (content: string) => {
  message.warning(content);
};

export const loading = (content: string, duration: number = 0) => {
  message.loading(content, duration);
};

export const destroy = () => {
  message.destroy();
};

type NotificationType = 'success' | 'info' | 'warning' | 'error';

export const notification = (
  title: string,
  description: string,
  type: NotificationType = 'success',
) => {
  message.destroy();
  antNotification[type]({ message: title, description });
};
